import headingCardConfig from 'molecules/TextCard/headingtextcard.config';
import textCardConfig from 'molecules/TextCard/textcard.config';

import type { Input } from '@builder.io/sdk';

const TextCardsField = [
  {
    name: 'type',
    type: 'string',
    enum: ['headlineOnly', 'capps', 'cappsContained'],
    defaultValue: 'headlineOnly', // Default to 'headlineonly'
    required: true,
  },
  {
    name: 'heading',
    type: 'richText',
  },
  {
    name: 'headingCards',
    type: 'list',
    subFields: headingCardConfig.inputs,
    showIf: (options: any) => options.get('type') === 'headlineOnly',
  },
  {
    name: 'textCards',
    type: 'list',
    subFields: textCardConfig.inputs,
    showIf: (options: any) => options.get('type') === 'capps' || options.get('type') === 'cappsContained',
  },
] as const satisfies DeepReadonly<Input[]>;

const TextCardsConfig = {
  name: 'Text Cards',
  inputs: TextCardsField,
};

export type TextCardsProps = GenerateBuilder<typeof TextCardsField>;

export default TextCardsConfig;
